import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { Box, Button, Paper, Typography } from "@mui/material";
import React from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate, useSearchParams } from "react-router-dom";
import styled from "styled-components/macro";

import { ReactComponent as Logo } from "../../../vendor/logo-dark.svg";

const Wrapper = styled(Paper)`
  padding: ${(props) => props.theme.spacing(6)};
  ${(props) => props.theme.breakpoints.up("md")} {
    padding: ${(props) => props.theme.spacing(10)};
  }
`;

const Brand = styled(Logo)`
  width: 150px;
  height: 50px;
  margin-bottom: 20px;
`;

const LogoCenter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

function AmazonError() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const errorMessage =
    searchParams.get("message") ||
    "An unexpected error occurred while connecting your Amazon account.";

  return (
    <React.Fragment>
      <Wrapper>
        <LogoCenter>
          <Brand />
        </LogoCenter>
        <Helmet title="Amazon Connection Error" />

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <ErrorOutlineIcon sx={{ fontSize: 64, color: "#f44336" }} />

          <Typography component="h1" variant="h4" align="center" gutterBottom>
            Connection Failed
          </Typography>

          <Typography
            component="h2"
            variant="body1"
            align="center"
            sx={{ color: "text.secondary", mb: 1 }}
          >
            {errorMessage}
          </Typography>

          <Typography
            variant="body2"
            align="center"
            sx={{ color: "text.secondary", mb: 3 }}
          >
            Please try again or contact support if the problem persists.
          </Typography>

          <Box sx={{ display: "flex", gap: 2 }}>
            <Button
              variant="outlined"
              size="large"
              onClick={() => navigate("/auth/amazon/connect")}
              sx={{ px: 4, py: 1.5 }}
            >
              Try Again
            </Button>
            <Button
              variant="contained"
              size="large"
              onClick={() => navigate("/")}
              sx={{ px: 4, py: 1.5 }}
            >
              Go to Dashboard
            </Button>
          </Box>
        </Box>
      </Wrapper>
    </React.Fragment>
  );
}

export default AmazonError;
